import { CLOVER, SHOPIFY, SQUARE } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
export var getPOSName = function(type) {
    var name;
    switch(type){
        case SQUARE:
            name = "Square";
            break;
        case SHOPIFY:
            name = "Shopify";
            break;
        case CLOVER:
            name = "Clover";
            break;
        default:
            name = "POS or online store";
    }
    return name;
};
